/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-sequences */
/* eslint-disable max-len */
import React from 'react';
import CommonSummary from '../CommonSummary';

export default function TradeSummary({ OrderDetails, type }) {
    return (
        <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
            <div className="border-b border-[#CBCBCB] pb-2.5">
                <div className="flex justify-between items-center">
                    <div>
                        <p className="text-sm font-semibold text-[#090406] order-change">Order Type</p>
                        <p className="sm:text-lg text-base font-normal text-[#555259]" data-testid="order-type">Trade Order</p>
                    </div>

                </div>
                <div className="mt-3">
                    <p className="text-sm font-semibold text-[#090406]">Quantity</p>
                    <div className="items-center flex justify-between mt-2">
                        <p className="font-normal text-sm text-[#555259]">Line Items selected</p>
                        <p className="font-normal text-sm text-[#555259]">{OrderDetails.total_items}</p>
                    </div>
                    <div className="items-center flex justify-between mt-2 pb-3">
                        <p className="font-normal text-sm text-[#555259]">Net Order Quantity</p>
                        <p className="font-normal text-sm text-[#555259]">
                            {OrderDetails?.summary?.quantity && Object.keys(OrderDetails?.summary?.quantity).length > 0 && Object.keys(OrderDetails?.summary?.quantity).map((UOM, i) => (
                                <span style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className="font-semibold">
                                    {Number(OrderDetails?.summary?.quantity[UOM])}
                                    {' '}
                                    {UOM}
                                    {' '}
                                    <br />
                                </span>
                            ))}

                        </p>
                    </div>
                </div>
            </div>
            <div className="pt-1.5 order-change1">
                <CommonSummary Calculation={OrderDetails.summary} orderFlow="order" OrderDetails={OrderDetails} type={type} />

            </div>
            <div className="pt-1.5 hidden order-summary">
                <ul className="nav nav-pills flex list-none pl-0 pb-1.5 border-b border-[#CBCBCB]" id="pills-tab" role="tablist">
                    <li className="nav-item w-1/2 text-center" role="presentation">
                        <a href="#pills-home" className="w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary1 active relative" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
                            Order Summary
                        </a>
                    </li>
                    <li className="nav-item w-1/2 text-center" role="presentation">
                        <a href="#pills-profile" className="w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary1 relative" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                            Proposed Summary
                        </a>
                    </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <div>
                            <div className="py-1 border-b border-[#CBCBCB]">
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">₹4,96,000.00</p>
                                </div>
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Discount</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">₹10,000.00</p>
                                </div>
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">DAP</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">-</p>
                                </div>
                            </div>
                            <div>
                                <div className="flex justify-between items-center mt-1.5">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Sub Total</p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">₹4,96,000.00</p>
                                </div>
                                <div className="flex justify-between items-center mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Ador Cash redeemed </p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">₹20,000.00</p>
                                </div>
                                <div className="flex justify-between items-center mt-1.5">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Amount</p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">₹4,96,000.00</p>
                                </div>
                            </div>
                            <div className="py-1 border-b border-t border-[#CBCBCB]">
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST (18%)*</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">₹89,280.00 </p>
                                </div>
                            </div>
                            <div className="py-1">
                                <div className="flex justify-between items-center mt-1.5">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Gross Amount</p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">₹5,85,280.00</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade px-1" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                        <div>
                            <div className="py-1 border-b border-[#CBCBCB]">
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">₹4,96,000.00</p>
                                </div>
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Discount</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">₹10,000.00</p>
                                </div>
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">DAP</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">-</p>
                                </div>
                            </div>
                            <div>
                                <div className="flex justify-between items-center mt-1.5">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Sub Total</p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">₹4,96,000.00</p>
                                </div>
                                <div className="flex justify-between items-center mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Ador Cash redeemed </p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">₹20,000.00</p>
                                </div>
                                <div className="flex justify-between items-center mt-1.5">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Net Amount</p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">₹4,96,000.00</p>
                                </div>
                            </div>
                            <div className="py-1 border-b border-t border-[#CBCBCB]">
                                <div className="flex justify-between items-center sm:mt-0 mt-1">
                                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST (18%)*</p>
                                    <p className="sm:text-lg text-base font-semibold text-[#555259]">₹89,280.00 </p>
                                </div>
                            </div>
                            <div className="py-1">
                                <div className="flex justify-between items-center mt-1.5">
                                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Gross Amount</p>
                                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]" data-testid="total-amt">₹5,85,280.00</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
